import { Pipe, PipeTransform } from '@angular/core';
import { TicketType } from '@shared/enums/TicketType';
import { ITicketItem } from '@shared/services/api/legacy/tickets-service/tickets-model';

@Pipe({
  name: 'ticketType'
})
export class TicketTypePipe implements PipeTransform {
  public transform(ticketItems: ITicketItem[], ...validTypes: TicketType[]): ITicketItem[] {
    return ticketItems?.filter(i => validTypes.includes(i.ticketType));
  }
}
